import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightboxResetPwd>({
  components: {}
})
export default class LightboxResetPwd extends Vue {
    // input
    private oriPwd = "";
    private newPwd = "";
    private againPwd = "";
    // msg
    private rule = false;
    private diff = false;

    // prop in
    @PropSync("info", { type: Object })
    syncedInfo!: {
        show: boolean,
        ori: string,
        new: string,
        err: boolean,
    };

    // event out
    private close() {
        this.$emit("close"); // 觸發的事件名稱
    }

    private submit() {
        this.syncedInfo.err = false;

        // valid
        console.log(this.newPwd);
        console.log(this.againPwd);

        this.rule = false;
        if (this.newPwd === "") { //ss rule => 請輸入至少6位(大小寫英文字母或符號)密碼
            this.rule = true;
        }

        this.diff = false;
        if (this.newPwd === "" || this.againPwd === "" || this.newPwd !== this.againPwd) {
            this.diff = true;
        }

        if (this.rule || this.diff) {
            return false;
        }

        // submit to check
        this.syncedInfo.ori = this.oriPwd as string;
        this.syncedInfo.new = this.newPwd as string;

        this.$emit("submit", this.syncedInfo); // 觸發的事件名稱
    }
}